import type { DragLayerMonitor } from 'react-dnd';

export class DragLayerRef {
  dragLayerRef: HTMLElement | null = null;

  getElement(): HTMLElement | null {
    return this.dragLayerRef;
  }

  setElement(dragLayerRef: HTMLElement | null): void {
    this.dragLayerRef = dragLayerRef;
  }

  hasDragLayerRef(): boolean {
    return this.dragLayerRef !== null;
  }

  setTransform(transform: string): void {
    if (this.dragLayerRef) {
      this.dragLayerRef.style.transform = transform;
    }
  }

  setDisplay(display: string): void {
    if (this.dragLayerRef) {
      this.dragLayerRef.style.display = display;
    }
  }
}

interface DragLayerCollector {
  item: ReturnType<DragLayerMonitor['getItem']>;
  itemType: ReturnType<DragLayerMonitor['getItemType']>;
}

export const dragLayerCollector =
  (dragLayerRef: DragLayerRef) =>
  (monitor: DragLayerMonitor): DragLayerCollector => {
    if (dragLayerRef.hasDragLayerRef()) {
      const offset =
        monitor.getSourceClientOffset() || monitor.getInitialClientOffset();

      if (offset) {
        dragLayerRef.setTransform(`translate(${offset.x}px, ${offset.y}px)`);
      } else {
        dragLayerRef.setDisplay('none');
      }
    }

    return {
      item: monitor.getItem(),
      itemType: monitor.getItemType(),
    };
  };
